import React from 'react';
import { DropZone } from '@measured/puck';

// Flex layout component
const FlexComponent = ({ 
  direction = 'row', 
  gap = '16px', 
  alignItems = 'stretch',
  justifyContent = 'flex-start',
  wrap = 'nowrap'
}) => {
  return (
    <DropZone
      zone="flex-zone"
      style={{
        display: 'flex',
        flexDirection: direction,
        gap: gap,
        alignItems: alignItems,
        justifyContent: justifyContent,
        flexWrap: wrap,
        width: '100%'
      }}
    />
  );
};

export const Flex = {
  fields: {
    direction: {
      type: 'select',
      label: 'Richtung',
      options: [
        { label: 'Horizontal (Zeile)', value: 'row' },
        { label: 'Vertikal (Spalte)', value: 'column' },
        { label: 'Horizontal umgekehrt', value: 'row-reverse' },
        { label: 'Vertikal umgekehrt', value: 'column-reverse' }
      ]
    },
    gap: {
      type: 'select',
      label: 'Abstand zwischen Elementen',
      options: [
        { label: 'Klein (8px)', value: '8px' },
        { label: 'Mittel (16px)', value: '16px' },
        { label: 'Groß (24px)', value: '24px' },
        { label: 'Sehr groß (32px)', value: '32px' }
      ]
    },
    alignItems: {
      type: 'select',
      label: 'Vertikale Ausrichtung',
      options: [
        { label: 'Strecken', value: 'stretch' },
        { label: 'Oben', value: 'flex-start' },
        { label: 'Mitte', value: 'center' },
        { label: 'Unten', value: 'flex-end' },
        { label: 'Basislinie', value: 'baseline' }
      ]
    },
    justifyContent: {
      type: 'select',
      label: 'Horizontale Ausrichtung',
      options: [
        { label: 'Links', value: 'flex-start' },
        { label: 'Mitte', value: 'center' },
        { label: 'Rechts', value: 'flex-end' },
        { label: 'Zwischen', value: 'space-between' },
        { label: 'Umherum', value: 'space-around' },
        { label: 'Gleichmäßig', value: 'space-evenly' }
      ]
    },
    wrap: {
      type: 'select',
      label: 'Umbruch',
      options: [
        { label: 'Kein Umbruch', value: 'nowrap' },
        { label: 'Umbruch erlaubt', value: 'wrap' },
        { label: 'Umbruch umgekehrt', value: 'wrap-reverse' }
      ]
    }
  },
  render: FlexComponent
};
